import { useGlobalDependencyProvider } from "@teachino/shared-util";
import { AIModeId, AIPromptId } from "~/composables/ai/promptData";
import { CalendarEventType } from "~/graphql";
// mixpanel


export type TrackItemCreateLocation =
  | 'library'
  | 'period'
  | 'template'
  | 'course'
  | 'ai_chat';

export default function () {
  let tenantIds = useState<string[]>('tenantIds', () => []);

  function trackCourseCreated(
    type: 'course' | 'template',
    fromTemplate: boolean,
  ) {
    // checked!
    trackEvent('course-created', {
      type,
      fromTemplate,
    });
  }

  function trackTopicCreated(
    location: TrackItemCreateLocation,
    numberOfCourses: number,
    createdWithAi: boolean = false,
  ) {
    //checked!
    trackEvent('topic-created', {
      location,
      numberOfCourses,
      createdWithAi,
    });
  }

  function trackItemCreationStarted(location: TrackItemCreateLocation) {
    trackEvent('item-creation-started', {});
  }


  function trackItemCreated(
    location: TrackItemCreateLocation,
    initialSnippets: number,
    createdWithAi: boolean = false,
  ) {
    // checked
    trackEvent('item-created', {
      location,
      initialSnippets,
      createdWithAi,
    });
  }

  function trackSnippetCreated(
    type: 'image' | 'file' | 'link' | 'text' | 'note' | 'external',
    createdWithItem: boolean = false,
    createdWithAi: boolean = false,
  ) {
    // checked
    trackEvent('snippet-created', {
      type,
      createdWithItem,
      createdWithAi,
    });
  }

  function trackCalendarEventAddedToPeriod(
    type: CalendarEventType,
    createdWithAI: boolean = false,
    primaryNote: boolean = false,
    createdOnPeriod: boolean = false,
  ) {
    //checked
    trackEvent('calendar-event-added-to-period', {
      type,
      createdWithAI,
      primaryNote,
      createdOnPeriod,
    });
  }

  function trackCalendarEventMoved() {
    // checked!
    trackEvent('calendar-event-moved', {});
  }

  function trackAIStarted(mode: AIModeId) {
    // checked!
    trackEvent('ai-started', {
      mode: mode,
    });
  }

  function trackAISettingsNeeded() {
    // checked!
    trackEvent('ai-settings-needed');
  }

  function trackAISettingsCompleted() {
    // checked!
    trackEvent('ai-settings-completed');
  }

  function trackAIPromptSelected(prompt: AIPromptId) {
    // checked!
    trackEvent('ai-prompt-selected', {
      prompt,
    });
  }

  function trackAISuggestionsCompleted(prompt: AIPromptId) {
    // checked!
    trackEvent('ai-suggestions-completed', {
      prompt,
    });
  }

  function trackAISaved(prompt: AIPromptId, numberOfSelections: number) {
    // checked!
    trackEvent('ai-saved', {
      prompt,
      numberOfSelections,
    });
  }

  function trackPresentationStarted() {
    // checked!
    trackEvent('presentation-started');
  }

  function trackPresentationElementShown() {
    // checked!
    trackEvent('presentation-element-shown');
  }

  function trackPeriodClassRegisterWritten(mode: 'integration' | 'clipboard') {
    // checked!
    trackEvent('period-class-register-written', {
      mode,
    });
  }

  function trackTodoCreated() {
    // checked!
    trackEvent('todo-created');
  }

  function trackTodoCompleted() {
    // checked!
    trackEvent('todo-completed');
  }

  function trackItemInstanceVisibilityChanged( // checked
    visibility: 'visible' | 'hidden',
  ) {
    trackEvent('item-instance-visibility-changed', { visibility });
  }

  function trackTopicInstanceDatesSet() {
    // checked
    trackEvent('topic-instance-date-set');
  }

  function trackTopicAddedFromLibrary() {
    // TODO
  }

  function trackTopicDuplicated(
    source: 'library' | 'template',
    target: 'library' | 'template',
  ) {
    // TODO
  }

  function trackItemDuplicated(
    source: 'library' | 'template',
    target: 'library' | 'template',
  ) {
    // TODO
  }

  function trackPageViewed(path: string) {
    // TODO
  }

  function trackPrint(mode: 'week' | 'year') {
    // checked
    trackEvent('print', { mode });
  }

  function trackInviteAccepted(mode: 'template' | 'course') {
    // TODO
  }

  function trackStudentViewed(role: 'teacher' | 'student') {
    // checked!
    trackEvent('student-viewed', {
      role,
    });
  }

  function trackSignUpEmailEntered(source: 'direct' | 'website') {
    // checked!
    trackEvent('signup-email-entered', { source });
  }

  function trackSignupStarted() {
    // checked!
    trackEvent('signup-started');
  }

  function trackSignupCompleted() {
    // checked!
    trackEvent('signup-completed');
  }

  function trackSignUpEmailVerificationStarted(type: 'manual' | 'link') {
    // checked!
    trackEvent('signup-email-verification-started', {type});
  }

  function trackSignUpEmailVerified() {
    // checked!
    trackEvent('signup-email-verified');
  }

  function trackSignupMasterDataCompleted(integration: boolean) {
    // checked!
    trackEvent('signup-masterdata-completed', {
      integration,
    });
  }

  function trackOnboardingCreateCoursesStarted(mode: 'integration' | 'manual') {
    // checked!
    trackEvent('onboarding-create-courses-started', { mode });
  }

  function trackOnboardingCreateCoursesCompleted(
    mode: 'integration' | 'manual',
    numOfCourses: number,
  ) {
    // checked!
    trackEvent('onboarding-create-courses-completed', {
      mode,
      numOfCourses,
    });
  }

  function trackOnboardingFirstStepSelected(mode: 'ai' | 'plan') {
    trackEvent('onboarding-first-step-selected', {
      mode,
    });
  }

  function trackIntegrationConnected(integrationKey: string) {
    // checked!
    trackEvent('integration-connected', {
      integrationKey,
    });
  }

  function trackPeriodCreated(mode: 'personal' | 'course') {
    // checked!
    trackEvent('period-created', {
      mode,
    });
  }

  function trackPeriodOpened() {
    // checked!
    trackEvent('period-opened');
  }

  function trackTimetableEditStarted(mode: 'simple' | 'expert') {
    trackEvent('timetable-edit-started', {
      mode,
    });
  }

  function trackTimetableEditCompleted(
    mode: 'simple' | 'expert',
    numOfPeriods: number,
  ) {
    trackEvent('timetable-edit-completed', {
      mode,
      numOfPeriods,
    });
  }

  function trackEvent(eventName: string, data: Object = {}) {

    try {
      const globalDi = useGlobalDependencyProvider();
      const analytics = globalDi.inject('analytics');
      // tracking old events to new typed analytics service
      analytics.track(eventName, {
        ...data,
        parent_tenant_id: tenantIds.value,
      });
    } catch (e) {
      console.log(e);
    }
  }
  return {
    trackCourseCreated,
    trackItemCreated,
    trackCalendarEventAddedToPeriod,
    trackCalendarEventMoved,
    trackSnippetCreated,
    trackAIStarted,
    trackAISettingsNeeded,
    trackAISettingsCompleted,
    trackAIPromptSelected,
    trackAISuggestionsCompleted,
    trackAISaved,
    trackTopicCreated,
    trackPresentationStarted,
    trackPresentationElementShown,
    trackPeriodClassRegisterWritten,
    trackTodoCreated,
    trackTodoCompleted,
    trackItemInstanceVisibilityChanged,
    trackTopicInstanceDatesSet,
    trackTopicAddedFromLibrary,
    trackTopicDuplicated,
    trackItemDuplicated,
    trackPageViewed,
    trackPrint,
    trackInviteAccepted,
    trackPeriodCreated,
    trackStudentViewed,
    trackSignupStarted,
    trackSignupCompleted,
    trackSignUpEmailEntered,
    trackSignUpEmailVerificationStarted,
    trackSignUpEmailVerified,
    trackSignupMasterDataCompleted,
    trackOnboardingCreateCoursesStarted,
    trackOnboardingCreateCoursesCompleted,
    trackOnboardingFirstStepSelected,
    trackIntegrationConnected,
    trackPeriodOpened,
    trackTimetableEditStarted,
    trackTimetableEditCompleted,
    trackItemCreationStarted,
  };
}
